import React, { useState, useEffect } from 'react';
import ReportSummarySlider from '../../components/Home/ReportSummarySlider';
import useReports from '../../hooks/useReports';
import VulnerabilitiesSummary from '../../components/Home/VulnerabilitiesSummary';
import ChartsSection from '../../components/Home/ChartsSection';
import NewsSection from '../../components/Home/NewsSection';
import PhishingAttempts from '../../components/Home/PhishingAttempts';

const DEFAULT_REPORT_ID = process.env.REACT_APP_DEFAULT_REPORT_ID!;

const Home: React.FC = () => {
  const [selectedReportId, setSelectedReportId] = useState<string | null>(null);
  const { reports, reportSummary, error, loading } = useReports(selectedReportId);

  useEffect(() => {
    // Si no hay datos o ya tenemos seleccionado algo, salimos
    if (!reports || reports.length === 0 || selectedReportId) return;
  
    if (reports.length === 1) {
      setSelectedReportId(reports[0].id);
    } else {
      const pool = reports.filter(r => r.id !== DEFAULT_REPORT_ID);
      const choices = pool.length ? pool : reports;
      const randomIdx = Math.floor(Math.random() * choices.length);
      setSelectedReportId(choices[randomIdx].id);
    }
  }, [reports, selectedReportId]);
  

  return (
    <div className="grid grid-cols-1 gap-6 lg:grid-cols-3 lg:grid-rows-[auto auto]">
      {/* Parte de informes + news */}
      <div className="lg:col-span-2 flex flex-col h-full">
        <ReportSummarySlider
          reports={reports}
          selectedReportId={selectedReportId}
          onSelectReport={setSelectedReportId}
          reportSummary={reportSummary}
          loading={loading}
          error={error}
        />
      </div>
      <div className="flex flex-col h-full">
        <NewsSection />
      </div>

      {/* Sección inferior */}
      <div className="lg:col-span-3 space-y-6">
        <PhishingAttempts />
        <div className="bg-[#0f172a] border border-gray-800 shadow-lg p-6 rounded-lg space-y-8">
          <VulnerabilitiesSummary />
          <ChartsSection />
        </div>
      </div>
    </div>
  );
};

export default Home;
